// 繁体中文
export default {
    public: {
        call :'您好！',
        logout: '登出登入',
        delSuccess:'刪除成功',
        switching:'切換多語言成功',
        login: '登入/註冊',
    },
    ykpHeader: {
        product: '產品',
        productList: '產品列表',
        // 左侧产品相关
        allProducts: '全部產品',
        searchLiterature: '搜文獻',
        readLiterature: '讀文獻',
        writeLiterature: '寫文獻',
        translateLiterature: '翻譯文獻',
        
        // 用户相关
        userProduct: '用戶產品',
        personalCenter: '個人中心',
        problemFeedback: '問題反饋',
        logout: '退出登錄',
        
        // 问题反馈弹窗
        functionModule: '功能模塊：',
        selectModule: '請選擇存在問題的功能模塊',
        problemDescription: '問題描述：',
        enterDescription: '請輸入問題描述',
        problemScreenshot: '問題截圖：',
        email: '郵箱：',
        enterEmail: '請輸入郵箱',
        cancel: '取 消',
        submit: '提 交',
        feedbackSuccess: '問題反饋成功！',
        
        // 登录相关
        loginType: '登錄類型',
        confirm: '確定',
        pleaseLogin: '請先登錄',
        loginExpired: '登錄已失效',
        pleaseUsePersonalAccount: '請使用個人賬號登錄',
        
        // 表单验证
        pleaseSelectModule: '請選擇功能模塊',
        pleaseEnterDescription: '請輸入問題描述',
        pleaseEnterEmail: '請輸入郵箱'
    },
}